import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import { useRequest } from '../../../../../hooks';
import { brsStepCodeSelAPI } from '../../../../../api/progressLearningAPI';

function StepSelectBox({ defaultValue, handleCodeSet }) {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState("");
  const [stepCodeSel, code] = useRequest(() => brsStepCodeSelAPI());

  useEffect(() => {
    setStep(defaultValue);
  }, [defaultValue])

  useEffect(() => {
    stepCodeSel();
  }, [stepCodeSel]);

  const handleOnOffClick = () => {
    setOpen(!open)
  };

  const handleStepClick = (value) => {
    setStep(value);
    handleOnOffClick();
    handleCodeSet('step', value);
  }

  return (    
    <div className="area">
      <div
        className={clsx('new-select m_40', open && 'opened')}
      >
        <div
          className={clsx({
            "selected_txt": true,
            "first": step === ""
          })}
          onClick={handleOnOffClick}
        >
          {step !== "" ? <span>{step}단계</span> : "단계"}
        </div>
        <div className="select_option">
          <ul>
            <li>
              <button
                type="button"
                className={step === "" ? "selected" : ''}
                onClick={() => handleStepClick("")}
              >
                단계
              </button>
            </li>
            {
              code && (
                code.brsStepCdList.map((item) => (
                  <li key={item}>
                    <button
                      type="button"
                      className={step === item ? "selected" : ''}
                      onClick={() => handleStepClick(item)}
                    >
                      {item}단계
                    </button>
                  </li>
                ))
              )
            }
          </ul>
        </div>
      </div>
    </div>
  );
}

export default StepSelectBox;